import styled from 'styled-components';

export const ProductsMayLikeSection = styled.section`
  position: relative;
  margin-top: 26px;

  h1 {
    font-size: clamp(18px, 2vw, 22px);
    font-weight: 600;
    color: hsl(0deg, 0%, 0%, 87%);
    letter-spacing: 3px;
    text-align: center;

    @media (max-width: 720px) {
      padding-bottom: 16px;
    }
  }
`;

export const CardSection = styled.div`
  padding: 20px 22px 20px;
  border: ${(props) =>
    props.inThisArticle ? 'none' : '1px solid hsl(0deg, 0%, 0%, 10%)'};
  border-radius: 8px;
  margin-bottom: ${(props) => props.marginBottom || '30px'};
  position: ${(props) => (props.inThisArticle ? 'sticky' : 'static')};
  top: 134px;
  background-color: ${(props) => (props.popularTools ? '#f7f7f7' : '#fff')};
  max-height: 321px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 5px;

    @media (max-width: 720px) {
      width: 0;
    }
  }
  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
  }
  &::-webkit-scrollbar-track {
    background-color: #fff;
  }

  @media (max-width: 720px) {
    max-height: none;
    border: none;
    margin: 10px 7px 0px;
    padding: 10px 22px 0px;
    display: ${(props) =>
      props.inThisArticle || props.topicList ? 'none' : 'block'};
  }

  &.notVisible {
    visibility: hidden;
  }

  &.visible {
    visibility: visible;
  }
  &.transitionClass {
    transition: all 0.2s ease-in-out;
  }
  &.gridcardopacity {
    opacity: 0.5;
  }
`;

export const CardTitle = styled.h3`
  color: hsl(0deg 0% 0% / 70%);
  font-size: clamp(16px, 2vw, 20px);
`;

export const MotherStage = styled.p`
  font-size: 12px;
  font-weight: 500;
  color: #00000087;
  padding: 4px 0px;
`;

export const QuestionPara = styled.p`
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 14px;
  font-weight: 500;
  color: rgb(0 0 0 / 80%);
`;

export const RelatedQuestion = styled.div`
  padding: 16px 0;
  border-bottom: 1px solid hsl(0deg, 0%, 0%, 10%);
  transition: all 0.2s ease-in-out;
  &.gridcardopacity {
    opacity: 0.5;
  }
`;

export const ArticleList = styled.ul`
    margin-top: 30px;

    li {
        display: flex;
        align-items: flex-start;
        column-gap: 16px;
        margin: 20px 0;
        cursor: pointer;
        transition: transform 0.25s ease;
        backface-visibility: hidden;

        &:hover {
            transform: scale(1.05);
        }

        img {
            
            object-fit: cover;
            
        }
        span{
            flex-shrink:0;
        }
        p {
            font-size: 13px;
            font-weight: 500;
            color: hsl(0deg 0% 0% / 80%);
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }
        h3{
            font-size: 13px;
            color: hsl(0deg,0%,0%,80%);
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            font-weight: 500;
            opacity: 0.9;s
        }
    }
`;

export const CardSectionCover = styled.div`
  position: sticky;
  top: 160px;
  height: fit-content;
`;
